import { $ } from '@starberry/components';
import StarberryLogo from 'core/components/StarberryLogo';

const Footer = {
  $: 'ContentSection',
  props: {
    px: $('theme.space.12'),
    flexShrink: 0,
    pb: 5,
  },
  children: ({ footerTextProps, starberryLinkProps }) => {
    return [
      { $: 'Divider' },
      {
        $: 'Stack',
        props: {
          justify: 'space-between',
          direction: ['column', null, 'row'],
          spacing: 2,
        },
        children: [
          {
            $: 'Stack',
            props: {},
            children: [
              {
                $: 'Text',
                props: {
                  color: $('constants.colors.grey2'),
                  fontSize: 'sm',
                  ...footerTextProps
                },
                currentYear: new Date().getFullYear(),
                children: $`Copyright © ${'currentYear'}, ${'constants.site-name'}`,
              },
              {
                $: 'FooterMenu'
              },
            ],
          },
          {
            $: 'Stack',
            props: {
              direction: 'row',
              alignItems: 'center',
            },
            children: [
              { $: 'Text', props: { color: $('constants.colors.grey2'), fontSize: 'sm', ...footerTextProps }, children: $('constants.translations.footer.SITE_BY', 'Site by') },
              { $: 'Link', props: { href: 'https://starberry.tv/', d: 'flex', target: '_blank', _hover: { color: '#4e0087' }, ...starberryLinkProps }, children: { component: StarberryLogo } },
            ],
          },
        ],
      },
    ];
  },
};

export default Footer;
